import { useState, useEffect } from 'react'

const useScript = (src, { target = self } = {}) => {
  const [ status, setStatus ] = useState('loading')

  useEffect(() => {
    const script = target.document.querySelector(`script[src="${src}"]`)

    if (script)
      setStatus(script.dataset.status || 'preexisting')
    else {
      const script = target.document.createElement('script')

      const handleScriptLoad = () => {
        script.dataset.status = 'ready'
        setStatus('ready')
        removeEventListeners()
      }

      const handleScriptError = () => {
        script.dataset.status = 'error'
        setStatus('error')
        removeEventListeners()
      }

      const removeEventListeners = () => {
        script.removeEventListener('load', handleScriptLoad)
        script.removeEventListener('error', handleScriptError)
      }

      script.addEventListener('load', handleScriptLoad)
      script.addEventListener('error', handleScriptError)

      script.dataset.status = status
      script.src = src
      target.document.body.appendChild(script)
    }
  }, [ src ])

  return status
}

export default useScript
